import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "./styles/DocSign.css";
import { useNavigate } from "react-router-dom";
import { useEtatGlobal } from "../../EtatGlobal.js";

import { GrDocumentDownload } from "react-icons/gr";

import { authFetch } from '../../../HttpClient';

import { dialog } from "../../../components/ui/Dialog";
import { referenceDuBrouillon } from "../lmBrouillon.js";
import { nomDocumentLM } from "../DocTypes/LMLIBRE/lmLibreDocument.js";
const SendDocForm = () => {
  const [loading, setLoading] = useState(false);
  const { utilisateur, formData, brouillonLm } = useEtatGlobal();
  const cabinet = formData?.lieu_collab?.trim() || null;

  const location = useLocation();
  console.log("STATE REÇU DANS VISUEL :", location.state, "Cabinet :", cabinet);
  const {
    pdfUrl,
    nom_client,
    email,
    comptable,
    selectedForm,
    leadId,
    clientId,
    civilite_lm,
    nom,
    prenom,
    telephone,
    siren,
    nombreLignesTableau,
    nombreLignesTexteLibre,
    formeSociale,
    societeNom,
    avenant,
  } = location.state || {};
  const navigate = useNavigate();

  const handleOpenDetails = () => {
    navigate("/home", {
      state: {
        pdfUrl,
        nom_client,
        email,
        comptable,
        selectedForm,
        display: false,
        leadId,
        clientId,
        civilite_lm,
        nom,
        prenom,
        telephone,
        siren,
        nombreLignesTableau,
        nombreLignesTexteLibre,
        formeSociale,
        societeNom,
        avenant,
      },
    });
  };

  console.log("Assistant :", utilisateur.lastName, utilisateur.name, "Cabinet :", cabinet);

  // Titre de la LM soumise : nom du modèle, sauf la LM libre (« LM [nom de la mission] »).
  const formWithoutExtension = nomDocumentLM(selectedForm, formData);

  console.log("Form without extension:", formWithoutExtension, "Cabinet :", cabinet);

  const handleSubmitLM = async () => {
    try {
      setLoading(true);

      const payload = {
        nom: nom,
        prenom: prenom,
        documentTitre: formWithoutExtension,
        signer: comptable,
        assistant: `${utilisateur?.lastName} ${utilisateur?.name}`,
        assistantMail: utilisateur?.email,
        pdfUrl: pdfUrl,
        selectedForm: selectedForm,
        civilite_lm: civilite_lm,
        nom_client: nom_client,
        email: email,
        telephone: telephone,
        siren: siren,
        formeSociale: formeSociale,
        societeNom: societeNom,
        avenant: avenant,
        nombreLignesTableau: nombreLignesTableau,
        nombreLignesTexteLibre: nombreLignesTexteLibre,
        leadId: leadId,
        clientId: clientId,
        // Cabinet porteur de la LM ("LE TAMPON" / "SAINT-PIERRE"), sélectionné
        // dans le formulaire — à propager jusqu'à l'Envelope lors de la validation.
        cabinet,
        // Référence de la LM déjà attribuée au brouillon (le backend en crée
        // une si la LM n'a jamais été enregistrée en brouillon).
        reference: referenceDuBrouillon(brouillonLm, formData),
      };

      console.log("Payload envoyé à /api/send-lm-soumettre :", payload, "Cabinet :", cabinet);

      const response = await authFetch("https://backend-myalfa.vercel.app/api/send-lm-soumettre",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Erreur lors de l’envoi");
      }

      dialog.alert(`Document envoyé à ${comptable}.`);
    } catch (error) {
      console.error(error, "Cabinet :", cabinet);
      dialog.alert("Une erreur est survenue lors de l’envoi.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="Sign">
      {pdfUrl && (
        <div className="pdf-container" style={{ position: "relative" }}>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            <Viewer
              fileUrl={pdfUrl}
              defaultScale={1.2}
              onDocumentLoadFail={(error) => {
                console.error("Erreur de chargement du PDF :", error, "Cabinet :", cabinet);
              }}
            />
          </Worker>
        </div>
      )}

      <div className="BottomNavbar">
        <button
          onClick={() => navigate("/home", { state: { dataSave: true } })}
          className="BtnVisuel"
        >
          Revenir sur l'Application
        </button>

        {pdfUrl && (
          <a href={pdfUrl} download="document.pdf" className="BtnDownload">
            <GrDocumentDownload color="#840040" size={25} />
          </a>
        )}
        <button
          type="button"
          className="BtnVisuel"
          onClick={handleSubmitLM}
          disabled={loading}
        >
          {loading ? "LM en cours d'envoie ..." : "Soumettre cette LM"}
        </button>
        <button onClick={handleOpenDetails} className="BtnVisuel">
          Signer ce Document
        </button>
      </div>
    </div>
  );
};

export default SendDocForm;
